export default "__VITE_ASSET__DcHa0S2w__"